/**
 * Single source of truth for the org-service office-detail route (GOTU-4959).
 *
 * Dependency-free on purpose: both the RQ fetcher (`officeDetailApi`) and the saga path
 * (`services/api.js`) import it, so the route string lives in ONE place without
 * reintroducing an `api.js` <-> `officeDetailApi` import cycle.
 */
export const officeDetailPath = (officeId: string): string => `/office/${officeId}`;
